module.exports = __webpack_public_path__ + "media/assets/unten-895e6d51c8f077d0a051f1f899a62536.svg";